.horizontalBreakout {
    display: none;
}
.verticalBreakout {
    display: block;
}

@media (min-width: 768px) {
    .horizontalBreakout {
        display: table;
    }
    .verticalBreakout {
        display: none;
    }
}

.scoreArea {
    position: sticky;
    top: 0;
    background: white;
    z-index: 4;
}